import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24 4C12.96 4 4 12.96 4 24s8.96 20 20 20 20-8.96 20-20S35.04 4 24 4M8 24c0-8.84 7.16-16 16-16 3.7 0 7.1 1.26 9.8 3.38L11.38 33.8C9.26 31.1 8 27.7 8 24m16 16c-3.7 0-7.1-1.26-9.8-3.38L36.62 14.2C38.74 16.9 40 20.3 40 24c0 8.84-7.16 16-16 16" })
});
export default SvgBlock;
